export default "__VITE_ASSET__BE69VMbH__"